/**
 * 自动化任务翻译 - 英文
 * Automation - English
 */
import { AutomationTranslations } from './zh';

export const automationEn: AutomationTranslations = {
  // Basics
  title: 'Automation Tasks',
  subtitle: 'Manage and monitor all automation tasks',
  
  // Statistics
  totalTasks: 'Total Tasks',
  totalExecutions: 'Total Executions',
  recentFailures: 'Recent 24h Failures',
  successRate: 'Success Rate',
  active: 'Active',
  
  // Status
  statusActive: 'Active',
  statusPaused: 'Paused',
  statusDisabled: 'Disabled',
  
  // Execution status
  execSuccess: 'Success',
  execFailed: 'Failed',
  execRunning: 'Running',
  execPending: 'Pending',
  execTimeout: 'Timeout',
  execCancelled: 'Cancelled',
  
  // Task types
  typeLdapSync: 'Entra ID Sync',
  typeDataCleanup: 'Data Cleanup',
  typeReportGeneration: 'Report Generation',
  typeNotification: 'Notification',
  typeBackup: 'Data Backup',
  typeCustom: 'Custom Task',
  
  // Filters
  allTypes: 'All Types',
  allStatuses: 'All Statuses',
  
  // Table columns
  taskName: 'Task Name',
  type: 'Type',
  status: 'Status',
  lastRun: 'Last Run',
  lastResult: 'Last Result',
  statistics: 'Statistics',
  total: 'Total',
  success: 'Success',
  failed: 'Failed',
  
  // Actions
  execute: 'Execute',
  pause: 'Pause',
  resume: 'Resume',
  viewLogs: 'View Logs',
  
  // Messages
  noTasks: 'No tasks available',
  taskNotFound: 'Task not found',
  confirmExecute: 'Are you sure you want to execute this task now?',
  executeStarted: 'Task execution started',
  executeFailed: 'Execution failed',
  
  // Detail page
  taskInfo: 'Task Information',
  executionHistory: 'Execution History',
  executionLogs: 'Execution Logs',
  description: 'Task Description',
  scheduleType: 'Schedule Type',
  scheduleConfig: 'Schedule Configuration',
  timeout: 'Timeout',
  retryCount: 'Retry Count',
  creator: 'Creator',
  taskConfig: 'Task Configuration',
  startTime: 'Start Time',
  duration: 'Duration',
  triggerType: 'Trigger Type',
  actions: 'Actions',
  noExecutions: 'No execution records',
  executionId: 'Execution ID',
  errorMessage: 'Error Message',
  executionResult: 'Execution Result',
  selectExecution: 'Please select a record from execution history to view logs',
  back: 'Back',
};

